/**
 * filters nil values from an object
 */
const cleanObject = (obj) =>
  Object.fromEntries(
    Object.keys(obj)
      .filter(
        (key) => obj[key] && obj[key] !== 'undefined' && obj[key] !== 'null'
      )
      .sort((a) => (a === 'sort' ? -1 : 0))
      .map((key) => [key, obj[key]])
  );

export default cleanObject;
